import React from "react";
import {
  Box,
  Divider,
  Stack,
  Modal,
  Heading,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Button,
} from "@chakra-ui/core";

import CustomerDetailsView from "../common/CustomerDetailsView";
import OrderDetailsView from "../common/OrderDetailsView";

const FullOrderDetailsView = ({ order, setIsViewOrderDetails, isViewOrderDetails }) => {


  return (
    
    <Modal
      isCentered
      isOpen={isViewOrderDetails}
      onClose={() => {
        // setIsCreateLink(false);
      }}
      size="2xl"
    >
      <ModalOverlay />
      <form>
        <ModalContent py="20px" borderRadius="5px">
          <ModalBody color="primary.500">
            <Box mb="25px">
              <Heading textTransform="uppercase" textAlign="center" as="h3" size="lg">
                order details
              </Heading>
              <Divider />
            </Box>
              <CustomerDetailsView customerInfo={order.customer} />
              
              <OrderDetailsView order={order} />
          </ModalBody>
          <ModalFooter>
            <Stack w="90%" maxW="340px" m="auto">
                <Button
                fontWeight="bold"
                variantColor="success"
                  onClick={()=>{setIsViewOrderDetails(false)}}
                >
                  Close
                </Button>
            </Stack>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  );
};

export default FullOrderDetailsView;
